module.exports = __webpack_public_path__ + "static/media/listen_right.ba3773bc.png";